import {Component, OnInit, Input} from '@angular/core';
import {Pagination} from "../entities/pagination";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
    @Input() pagination: Pagination;
    @Input() route: string;
    @Input() routeParams: any;
    form: FormGroup;
    resultsPerPageOptions = [25, 50, 100, 200];

    constructor(
        private _router: Router,
        private _builder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.form = this._builder.group({
            currentPage: [this.pagination.current_page],
            resultsPerPage: [this.pagination.results_per_page]
        })
    }

    private navigate() {
        this._router.navigate([this.route], {
            queryParams: Object.assign({}, this.routeParams, {
                page: this.pagination.current_page,
                'results-per-page': this.pagination.results_per_page
            }),
            preserveQueryParams: false
        });
    }

    previousPage() {
        this.pagination.current_page--;
        this.navigate();
    }

    nextPage() {
        this.pagination.current_page++;
        this.navigate();
    }

    firstPage() {
        this.pagination.current_page = 1;
        this.navigate();
    }

    lastPage() {
        this.pagination.current_page = this.pagination.total_pages;
        this.navigate();
    }

    navigateToRequestedPage() {
        this.pagination.current_page = +this.form.controls['currentPage'].value;
        this.navigate();
    }

    setResultsPerPage() {
        this.pagination.current_page = 1;
        this.pagination.results_per_page = +this.form.controls['resultsPerPage'].value;
        this.navigate();
    }
}



// WEBPACK FOOTER //
// ./src/app/pagination/pagination.component.ts